module.exports = "import React from 'react';\n\nimport Slider from '~/components/slider';\n\nclass Example extends React.Component {\n\tstatic displayName = 'SliderExample';\n\n\trender() {\n\t\treturn (\n\t\t\t<Slider\n\t\t\t\tid=\"error-id\"\n\t\t\t\tlabel=\"Slider Label\"\n\t\t\t\terrorText=\"There is a problem with this field\"\n\t\t\t\taria-describedby=\"slider-error-message\"\n\t\t\t/>\n\t\t);\n\t}\n}\n\nexport default Example;\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./~/@salesforce/design-system-react/components/slider/__examples__/error.jsx
// module id = 923
// module chunks = 0